import React from "react";

/* A pencil over a page — "edit these details". Replaces the raw pen.svg the
   live edit cards import, which hardcodes its own stroke colour. */
export const PencilIcon = ({ size = 16, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
       aria-hidden="true" focusable="false" className={className}>
    <path d="M4 20h4.2l9.4-9.4a2.1 2.1 0 000-3l-1.2-1.2a2.1 2.1 0 00-3 0L4 15.8V20z"
          stroke="currentColor" strokeWidth="1.7"
          strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14.4 5.9l3.7 3.7" stroke="currentColor" strokeWidth="1.7"
          strokeLinecap="round" />
  </svg>
);

export default PencilIcon;
